import { getCurrentUser } from '$tablet-app/src/app/users/functions';
import { UserModel } from '@akin-home/user';
import { useFocusedChatState } from '../../focused_chat/hooks/useFocusedChatState';
import { CloseFocusedChatCommand, OpenFocusedChatCommand } from '../types';

type Params = {
  cmd: OpenFocusedChatCommand;
};

export function handleOpenFocusedChatCommand(params: Params) {
  const {
    cmd: { data },
  } = params;

  // Would be good to inject this as a dependency
  useFocusedChatState.getState().show({
    user: getCurrentUser() as UserModel,
    initial_prompt: data.initial_label_prompt
      ? { type: 'label', text: data.initial_label_prompt }
      : undefined,
  });
}

type CloseFocusChatParams = {
  cmd: CloseFocusedChatCommand;
};

export function handleClosedFocusedChatCommand(params: CloseFocusChatParams) {
  const {
    cmd: { data },
  } = params;

  // Would be good to inject this as a dependency
  useFocusedChatState.getState().close(data.after_close_label);
}
